import { render, staticRenderFns } from "./DocumentSignatureType.vue?vue&type=template&id=0a51f89d&scoped=true"
import script from "./DocumentSignatureType.vue?vue&type=script&lang=js"
export * from "./DocumentSignatureType.vue?vue&type=script&lang=js"
import style0 from "./DocumentSignatureType.vue?vue&type=style&index=0&id=0a51f89d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a51f89d",
  null
  
)

export default component.exports